
//For live use
export const API_URL = 'https://vhppmp.org/backend'; 
export const BASE_URL = 'https://vhppmp.org';



//For local use
// export const API_URL = 'http://localhost/hindubodh_old'; 
// export const BASE_URL = 'http://localhost:3000';